/*
Author: Chathuraka Mallawa Arachchi
Date: 25/09/2024
Copyright © 2024 Infix!. All rights reserved.
*/

import { TextArea } from "@/components/Atoms";
import InputLabel from "@/components/Atoms/InputLabel";
import { useUrlType, useResponseId } from "@/components/hooks";
import { RootState } from "@/reducers/store";
import { useValidate } from "@/state/survey/formSlice";
import { BasicAnswerSave, useUpdateAnswersSubmit } from "@/state/survey/saveAnswerSlice";
import { Utility, Validate } from "@/utils";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import poaAnswerDetails from "../../SurveyModel/poaQuestions/poaAnswerDetails";

const Textarea = (props: any) => {

    const { node, disabled, propClasses, onBlur } = props;

    const form = useSelector((state: RootState) => state.form);
    const validateInputField = useValidate();

    const { isPatient } = useUrlType();
    const { answerResponseId } = useResponseId();
    const updateAnswersDispatch = useUpdateAnswersSubmit();

    const hasExecuted = useRef(false);
    const [questionName, setQuestionName] = useState('');

    const { state = {} } = form[node.name];

    const [inputValue, setInputValue] = useState<string>(form[node.name].value as string);

    
    useEffect(() => {
        if (form[node.name].value !== inputValue) {
            setInputValue(form[node.name].value as string);
        }
    }, [form, inputValue, node.name]);


    const handleChange = (value: string, name: string) => {

        validateInputField(name, value, true);

        if (node.validationDependants) {
            node.validationDependants.forEach((element: string) => {
                validateInputField(element, form[element].value, true);
            });
        }
    };

    const handleOnBlur = () => {

        if (!isPatient && answerResponseId && !onBlur) {

            const answers: BasicAnswerSave[] =
                poaAnswerDetails.generateQuestionAnswerSubmitFormat(form, node);

            updateAnswersDispatch(answers, answerResponseId);
        }

        if (onBlur) onBlur();
    };


    useEffect(() => {

        if (
            !isPatient &&
            node &&
            form[node.name] &&
            questionName !== node.name &&
            !hasExecuted.current
        ) {

            validateInputField(node.name, form[node.name].value, true);
            setQuestionName(node.name);
            hasExecuted.current = true;
        }

    }, [form, questionName, node, isPatient, validateInputField]);

    return (
        <React.Fragment>

            <div
                className={`user-input text-area-wrap 
                ${Utility.getClassForWidthPx(node)} 
                ${node.name}
                ${!Utility.getClassForWidthPx(node) && !Utility.getClassForWidth(node) ? 'flex-1' : ''}
                ${Utility.getClassForWidth(node)} 
                ${!isPatient ? 'poa-input' : ''}
                input-border-top ${propClasses}`}
            >

                <InputLabel
                    label={node.title}
                    labelClasses="input-label"
                />

                {node.subTitle &&
                    <InputLabel
                        type="subTitle"
                        label={node.subTitle}
                        labelClasses="input-label"
                    />
                }

                <TextArea
                    disabled={disabled}
                    form={form}
                    isInValid={Validate.isInvalid(state)}
                    name={node.name}
                    value={inputValue}
                    onBlur={handleOnBlur}
                    onChange={handleChange}
                    propClasses={`textarea-input input-border ${disabled ? 'disabled' : ''}`}
                />

            </div>

        </React.Fragment>
    );
};

export default Textarea;